export const FEATURE_FLAGS = {
  RATING: process.env.NEXT_PUBLIC_FF_RATING === 'true',
  MENTOR_SUBSCRIPTION: process.env.NEXT_PUBLIC_FF_MENTOR_SUBSCRIPTION === 'true',
  MULTI_SLOT_BOOKING: process.env.NEXT_PUBLIC_FF_MULTI_SLOT_BOOKING === 'true',
  // Gates both the "Install Application" Settings menu entry and the
  // associated nudge badge/dot. The /settings/install page itself is left
  // routable so existing home-screen icons (which may have been added
  // before the rollout) keep working — only the discoverability surfaces
  // are flagged so we can enable PWA promotion gradually per stage.
  PWA_INSTALL: process.env.NEXT_PUBLIC_FF_PWA_INSTALL === 'true',
  // Gates the entire web push pipeline:
  //   - service worker registration (no SW = no push, no background badge)
  //   - the "Enable notifications" settings card
  //   - the Push column in the notification preferences matrix
  // Off on official stages (dev/gamma/production) until VAPID keys are
  // provisioned and the feature is signed off; on personal stages it's
  // enabled so engineers can dogfood end-to-end.
  PWA_PUSH: process.env.NEXT_PUBLIC_FF_PWA_PUSH === 'true'
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return FEATURE_FLAGS[flag];
}
